import { ComponentRecognizer } from '../../ComponentRecognizer/ComponentRecognizer';
import type { FooterBlockBadgesType } from '../types';

type BlockBadgesProps = {
  data: FooterBlockBadgesType;
};

export const BlockBadges = ({ data }: BlockBadgesProps) => (
  <div key={`block-badges-${data.id}`} className="flex gap-[0.8rem]">
    {data.paragraph?.map((item, index) => (
      <ComponentRecognizer
        // eslint-disable-next-line @eslint-react/no-array-index-key
        key={`block-badges-component-recognizer-${index}`}
        item={item}
      />
    ))}
  </div>
);
